import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
} from '@/api/speedlimitareaanalysisresultserv'

export default {
  state: {
    state_SpeedLimitAreaAnalysisResult_GetPageResult: null,
    state_SpeedLimitAreaAnalysisResult_GetDetailResult: null,
    state_SpeedLimitAreaAnalysisResult_GetClientPageResult: null,
    state_SpeedLimitAreaAnalysisResult_ExportExcelResult: null,
  },
  mutations: {
    SET_SPEEDLIMITAREAANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_SpeedLimitAreaAnalysisResult_GetPageResult = rst;
    },
    SET_SPEEDLIMITAREAANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_SpeedLimitAreaAnalysisResult_GetDetailResult = rst;
    },
    SET_SPEEDLIMITAREAANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_SpeedLimitAreaAnalysisResult_GetClientPageResult = rst;
    },
    SET_SPEEDLIMITAREAANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_SpeedLimitAreaAnalysisResult_ExportExcelResult = rst;
    },
  },
  actions: {
    SpeedLimitAreaAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SPEEDLIMITAREAANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SPEEDLIMITAREAANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SpeedLimitAreaAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SPEEDLIMITAREAANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SPEEDLIMITAREAANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SpeedLimitAreaAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SPEEDLIMITAREAANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SPEEDLIMITAREAANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SpeedLimitAreaAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SPEEDLIMITAREAANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SPEEDLIMITAREAANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_SpeedLimitAreaAnalysisResult_GetPageResult: state => {
      return state.state_SpeedLimitAreaAnalysisResult_GetPageResult;
    },
    get_SpeedLimitAreaAnalysisResult_GetDetailResult: state => {
      return state.state_SpeedLimitAreaAnalysisResult_GetDetailResult;
    },
    get_SpeedLimitAreaAnalysisResult_GetClientPageResult: state => {
      return state.state_SpeedLimitAreaAnalysisResult_GetClientPageResult;
    },
    get_SpeedLimitAreaAnalysisResult_ExportExcelResult: state => {
      return state.state_SpeedLimitAreaAnalysisResult_ExportExcelResult;
    },
  }
}